import VuexPersistence from "vuex-persist";
import CryptoService from "@/services/CryptoService";
const storage = {
    getItem: (key) => {
        const storage = sessionStorage.getItem(key);
        if (storage) {
            const decryptedStore = CryptoService.decode(storage);
            return JSON.parse(decryptedStore);
        }
    },
    setItem: (key, value) => {
        const valueToString = JSON.stringify(value);
        const encryptedValue = CryptoService.encode(valueToString);
        sessionStorage.setItem(key, encryptedValue);
    },
    removeItem: (key) => {
        sessionStorage.removeItem(key);
    },
};
export const vuexLocal = new VuexPersistence({
    storage: storage,
    modules: ["student-education"],
});
